import { Box, Grid, Stack, useTheme } from "@mui/material";
import TitleComponent from "../../../components/widgets/titleComponent";
import { useTranslation } from "react-i18next";
import SocialMediaDetails from "./socialMediaDetails";
import LinkedinIcon from '../../../assets/icons/linkedin.svg';
import FacebookIcon from '../../../assets/icons/facebook.svg';
import InstagramIcon from '../../../assets/icons/instagram.svg';
import XIcon from '../../../assets/icons/x.png';
import YoutubeIcon from '../../../assets/icons/youtube.svg';
import companyData from '../../../assets/data/company.json';
import PlayStoreIcon from '../../../assets/icons/play-store.svg';
import AppStoreIcon from '../../../assets/icons/app-store.svg';

const SocialMediaLayout = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    return (
        <>
            <Box 
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    px='5%'
                >
                    <TitleComponent 
                        title={t('contact.socialMedia.title')}
                        description={t('contact.socialMedia.description')}
                        centerMode
                    />

                    <Grid
                        direction='row'
                        justifyContent='center'
                        alignItems='center'
                        container
                        width='100%'
                        spacing={{xs: 5, md: 5}}
                    >
                        <Grid size={{xs: 6, md: 2.4}}>
                            <SocialMediaDetails 
                                icon={LinkedinIcon}
                                name={t('contact.socialMedia.linkedIn.label')}
                                description={t('contact.socialMedia.linkedIn.description')}
                                footer={t('contact.socialMedia.linkedIn.footer')}
                                link={companyData.contact.social_media.linkedin}
                            />
                        </Grid>

                        <Grid size={{xs: 6, md: 2.4}}>
                            <SocialMediaDetails 
                                icon={FacebookIcon}
                                name={t('contact.socialMedia.facebook.label')}
                                description={t('contact.socialMedia.facebook.description')}
                                footer={t('contact.socialMedia.facebook.footer')}
                                link={companyData.contact.social_media.facebook}
                            />
                        </Grid>

                        <Grid size={{xs: 6, md: 2.4}}>
                            <SocialMediaDetails 
                                icon={InstagramIcon}
                                name={t('contact.socialMedia.instagram.label')}
                                description={t('contact.socialMedia.instagram.description')}
                                footer={t('contact.socialMedia.instagram.footer')}
                                link={companyData.contact.social_media.instagram}
                            />
                        </Grid>

                        <Grid size={{xs: 6, md: 2.4}}>
                            <SocialMediaDetails 
                                icon={XIcon}
                                name={t('contact.socialMedia.x.label')}
                                description={t('contact.socialMedia.x.description')}
                                footer={t('contact.socialMedia.x.footer')}
                                link={companyData.contact.social_media.twitter}
                            />
                        </Grid>

                        <Grid size={{xs: 6, md: 2.4}}>
                            <SocialMediaDetails 
                                icon={YoutubeIcon}
                                name={t('contact.socialMedia.youtube.label')}
                                description={t('contact.socialMedia.youtube.description')}
                                footer={t('contact.socialMedia.youtube.footer')}
                                link={companyData.contact.social_media.youtube}
                            />
                        </Grid>

                        <Grid size={{xs: 6, md: 2.4}}>
                            <SocialMediaDetails 
                                icon={PlayStoreIcon}
                                name={t('contact.socialMedia.playStore.label')}
                                description={t('contact.socialMedia.playStore.description')}
                                footer={t('contact.socialMedia.playStore.footer')}
                                link={companyData.contact.social_media.playStore}
                            />
                        </Grid>

                        <Grid size={{xs: 6, md: 2.4}}>
                            <SocialMediaDetails 
                                icon={AppStoreIcon}
                                name={t('contact.socialMedia.appStore.label')}
                                description={t('contact.socialMedia.appStore.description')}
                                footer={t('contact.socialMedia.appStore.footer')}
                                link={companyData.contact.social_media.appStore}
                            />
                        </Grid>
                    </Grid>
                </Stack>
            </Box>
        </>
    );
}

export default SocialMediaLayout;